import { render, staticRenderFns } from "./DeleteVideoDialog.vue?vue&type=template&id=793ecdb8&scoped=true"
import script from "./DeleteVideoDialog.vue?vue&type=script&lang=js"
export * from "./DeleteVideoDialog.vue?vue&type=script&lang=js"
import style0 from "./DeleteVideoDialog.vue?vue&type=style&index=0&id=793ecdb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793ecdb8",
  null
  
)

export default component.exports